import { Component, Input } from '@angular/core';

@Component({
  selector: 'evrideo-zoom-in-icon',
  templateUrl: './zoom-in-icon.component.html',
  styleUrls: ['./zoom-in-icon.component.scss'],
})
export class ZoomInIconComponent {
  @Input()
  overrideStyle: Record<string, string> = {};
}
